import { $ } from "@builder.io/qwik";
function useEnabledIndex() {
  const getNextEnabledItemIndex$ = $((index, itemsMap, loop) => {
    let offset = 1;
    const len = itemsMap.size;
    if (loop !== void 0 && !loop && index + 1 >= len) {
      return index;
    }
    while (offset < len) {
      const nextIndex = (index + offset) % len;
      if (!itemsMap.get(nextIndex)) {
        return nextIndex;
      }
      offset++;
      if (loop !== void 0 && !loop && index + offset >= len) {
        break;
      }
    }
    return index;
  });
  const getPrevEnabledItemIndex$ = $((index, itemsMap, loop) => {
    let offset = 1;
    const len = itemsMap.size;
    if (loop !== void 0 && !loop && index - 1 < 0) {
      return index;
    }
    while (offset <= len) {
      const prevIndex = (index - offset + len) % len;
      if (!itemsMap.get(prevIndex)) {
        return prevIndex;
      }
      offset++;
      if (loop !== void 0 && !loop && index - offset < 0) {
        break;
      }
    }
    return index;
  });
  return {
    getNextEnabledItemIndex$,
    getPrevEnabledItemIndex$
  };
}
export {
  useEnabledIndex
};
